import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const VerificationIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props} viewBox="0 0 16 16">
      <g fill="none">
        <path
          d="M13.8967 3.54812C11.5612 3.44298 9.43552 2.06183 8.43387 1.1696C8.3138 1.06264 8.1608 1 8 1C7.8392 1 7.6862 1.06264 7.56613 1.1696C6.56448 2.06183 4.43884 3.44298 2.10327 3.54812C1.51796 3.57446 0.98934 4.00209 1.00617 4.58775C1.10806 8.13304 2.50472 13.8439 7.6478 14.9783C7.71426 14.993 7.78363 15 7.85168 15H8.14832C8.21637 15 8.28573 14.993 8.3522 14.9783C13.4953 13.8439 14.8919 8.13304 14.9938 4.58775C15.0107 4.00209 14.482 3.57446 13.8967 3.54812Z"
          stroke="currentColor"
          strokeWidth="1.25"
        />
        <path
          d="M7.01475 10.3537L5.49575 8.83475C5.33475 8.67375 5.33475 8.41475 5.49575 8.25375C5.65675 8.09275 5.91575 8.09275 6.07675 8.25375L7.21775 9.39475C7.26675 9.44375 7.35075 9.44375 7.39975 9.39475L10.4238 6.37075C10.5848 6.20975 10.8438 6.20975 11.0048 6.37075C11.1658 6.53175 11.1658 6.79075 11.0048 6.95175L7.60275 10.3537C7.42775 10.5078 7.16875 10.5078 7.01475 10.3537Z"
          fill="currentColor"
        />
      </g>
    </IconSvgWrapper>
  );
};

export default VerificationIcon;
